import styled, { css } from 'styled-components';
import { WRAPPER } from '@/shared/styles/themes';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';

export const Wrapper = styled.div`
  ${WRAPPER}
  width: 100%;
  margin-top: 32px;
  margin-bottom: 32px;
  cursor: pointer;
  min-height: 220px;

  @media (max-width: 768px) {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    min-height: 220px;

    ${brandIsPh &&
    css`
      margin-left: 12px;
      margin-right: 12px;
      margin-top: 12px;
      width: auto;
      min-height: 0;
      height: auto;
    `}
  }
`;

const SlideContentSuper = css`
  display: flex;
  aspect-ratio: 16 / 9;
  height: 220px;
  width: 100%;

  @media (max-width: 768px) {
    aspect-ratio: 4 / 3;
    height: 420px;
  }

  @media (max-width: 640px) {
    aspect-ratio: 4 / 3;
    height: 320px;
  }

  @media (max-width: 560px) {
    aspect-ratio: 4 / 3;
    height: 280px;
  }

  @media (max-width: 389px) {
    aspect-ratio: 4 / 3;
    height: 240px;
  }

  @media (max-width: 320px) {
    aspect-ratio: 4 / 3;
    height: 220px;
  }
`;

export const SlideWrapperBound = styled.div`
  ${SlideContentSuper}

  & > span {
    width: 100%;
  }

  @media (max-width: 768px) {
    height: auto;
    aspect-ratio: 1 / 0.6875;
  }
`;
